import "./sw-editor.module.css";
import { html } from "lit-html";
import { LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

export default (user) => html`
    <div
        id="sw-editor"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-3xl font-semibold text-theme">
                        ${Strings.editor[LANGUAGE]}
                    </h3>
                    <button
                        title="${Strings.close[LANGUAGE]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-editor">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${Strings.close[LANGUAGE]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <form class="p-4 md:p-5">
                    <section
                        class="text-2xl font-medium w-full inline-flex items-center justify-between">
                        <label
                            for="sw-editor-input"
                            class="mb-2 text-gray-900 dark:text-white"></label>
                        <aside>
                            <input
                                class="hidden"
                                type="file"
                                id="sw-editor-mp3"
                                accept=".mp3" />
                            <button
                                title="${Strings.editor7[LANGUAGE]}"
                                type="button"
                                id="sw-editor-upload"
                                class="mr-2">
                                🔈
                            </button>
                            <button
                                title="${Strings.editor8[LANGUAGE]}"
                                type="button"
                                id="sw-editor-translate">
                                📑
                            </button>
                        </aside>
                    </section>
                    <textarea
                        id="sw-editor-input"
                        rows="4"
                        class="leading-[2.2] block p-2.5 w-full h-96 text-base md:text-xl text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-400 dark:placeholder-gray-400"
                        placeholder="${Strings.editor2[LANGUAGE]}"
                        required></textarea>
                    <section class="text-sm font-medium mt-5">
                        <progress
                            class="text-orange-500 w-full hidden"
                            value="0"
                            max="100"></progress>
                        <p
                            id="sw-editor-message"
                            class="text-green-500 dark:text-green-300"></p>
                    </section>
                    <section
                        class="w-full mt-5 inline-flex items-center justify-around">
                        <button
                            onclick="heartbank.alertAdmin('editor/click/submit')"
                            type="submit"
                            class="text-white w-28 disabled:opacity-50 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                            ${Strings.editor3[LANGUAGE]}
                        </button>
                        <button
                            data-modal-hide="sw-editor"
                            type="button"
                            class="text-white w-28 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                            ${Strings.close[LANGUAGE]}
                        </button>
                    </section>
                </form>
            </div>
        </div>
    </div>
`;
